import { useChatStore } from "../../stores/ChatStore";
import { useIntl } from "react-intl";
import { toAbsoluteUrl } from "../../_metronic/helpers";
import 'moment/locale/id';
import useUser from "../../hooks/User";
import { OverlayTrigger, Tooltip as TooltipBs } from "react-bootstrap";
import { ChatGroupParticipant } from "../../interfaces/Chat/Chat";
import { formatText } from "../../functions/general";
import { useState } from "react";

interface Props {
}

const DetailGroupContactChat = ({ }: Props) => {
    const { groupID, listChatGroupRooms, setIsOpenDetailGroupContact, selectedChatPhone, listChatGroupParticipants } = useChatStore()
    const intl = useIntl();

    const dataChatRoom = listChatGroupRooms[groupID]
    const [listParticipants, setListParticipants] = useState<ChatGroupParticipant[]>(dataChatRoom.participants);
    const [searchParticipant, setSearchParticipant] = useState("");

    const handleSearchParticipant = (event: React.ChangeEvent<HTMLInputElement>) => {
        const value = event.target.value.toLowerCase();
        setSearchParticipant(value);

        const filtered = dataChatRoom.participants.filter(
            (item) =>
                item.name?.toLowerCase().includes(value) ||
                item.phone?.toLowerCase().includes(value)
        );

        setListParticipants(filtered);
    };

    return (
        <div className="col-12 col-md-6 col-lg-6 col-xl-6" style={{ maxHeight: "calc(100vh - 1rem)", height: "calc(100vh - 1rem)", overflow: "auto", backgroundColor: "#f5f8fa" }}>

            <div className="card mb-5" style={{ backgroundColor: "#50cd89" }}>
                <h3 className="py-3 px-5 d-flex align-items-center gap-3 text-white">
                    <i className="fas fa-times fs-3 text-hover-white cursor-pointer text-white" onClick={() => setIsOpenDetailGroupContact(false)}></i>
                    {intl.formatMessage({ id: "FORM.LABEL.GROUP_CONTACT_DETAILS" })}
                </h3>
                <div className="card-body d-flex flex-center flex-column pt-5 px-5 pb-9">
                    <div className='symbol symbol-45px symbol-circle'>
                        <span className='symbol-label bg-light-danger text-danger fs-6 fw-bolder'>
                            <img src={toAbsoluteUrl('/media/logos/logo-wooblazz.png')} className='symbol symbol-45px symbol-circle img-fluid' style={{ padding: "10px" }} alt='profile' />
                        </span>
                    </div>
                    <div className="fs-4 fw-bolder d-flex gap-2 text-white">
                        {
                            dataChatRoom && selectedChatPhone.length > 1 &&
                            <OverlayTrigger
                                key={`bullet-${dataChatRoom.groupId}`}
                                placement='top'
                                overlay={
                                    <TooltipBs id='tooltip-labels'>
                                        <p><b>{dataChatRoom.as}</b></p>
                                        <span>{selectedChatPhone.find(item => item.phone === dataChatRoom.as)?.ownersName.join(', ')}</span>
                                    </TooltipBs>}
                            >
                                <div className="d-flex align-items-center">
                                    <span className="bullet bullet-dot h-10px w-10px" style={{ backgroundColor: dataChatRoom.color }}></span>
                                </div>
                            </OverlayTrigger>
                        }
                        {dataChatRoom.groupName}
                    </div>
                    {
                        dataChatRoom?.participants.length > 0 &&
                        <div className="fw-bold text-white">{dataChatRoom.participants.length} {intl.formatMessage({ id: "FORM.LABEL.MEMBER" })}</div>
                    }
                </div>
            </div>

            {
                dataChatRoom.groupDesc &&
                <div className="card mb-5">
                    <div className="card-body" style={{ padding: "2rem" }}>
                        <div className="d-flex align-items-center fs-4 text-gray-800 fw-bolder mb-3 gap-3">
                            {intl.formatMessage({ id: "FORM.LABEL.DESCRIPTION" })}
                        </div>
                        <div className="mt-3">
                            <div dangerouslySetInnerHTML={{ __html: formatText(dataChatRoom.groupDesc, listChatGroupParticipants, dataChatRoom, false, true) }} className='fw-normal' />
                        </div>
                    </div>
                </div>
            }

            {
                dataChatRoom?.participants.length > 0 &&
                <div className="card mb-5">
                    <div className="card-body" style={{ padding: "2rem" }}>
                        <div className="d-flex align-items-center fs-4 text-gray-800 fw-bolder mb-3 gap-3">
                            {dataChatRoom.participants.length} {intl.formatMessage({ id: "FORM.LABEL.MEMBER" })}
                        </div>
                        <span className="svg-icon svg-icon-1 position-absolute ms-3 mt-2">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                <rect opacity="0.5" x="17.0365" y="15.1223" width="8.15546" height="2" rx="1" transform="rotate(45 17.0365 15.1223)" fill="black" />
                                <path d="M11 19C6.55556 19 3 15.4444 3 11C3 6.55556 6.55556 3 11 3C15.4444 3 19 6.55556 19 11C19 15.4444 15.4444 19 11 19ZM11 5C7.53333 5 5 7.53333 5 11C5 14.4667 7.53333 17 11 17C14.4667 17 17 14.4667 17 11C17 7.53333 14.4667 5 11 5Z" fill="black" />
                            </svg>
                        </span>
                        <input type="search" onChange={handleSearchParticipant} value={searchParticipant} className="form-control form-control-sm form-control-solid ps-12" placeholder={intl.formatMessage({ id: 'MASTERS.DATATABLE.SEARCH.PLACEHOLDER' })} />
                        {
                            listParticipants.length > 0 ?
                                <div className="mt-3 d-flex flex-column gap-5">
                                    {
                                        listParticipants.map((participant: ChatGroupParticipant, index: number) => (
                                            <div key={index} className="d-flex align-items-center flex-wrap flex-grow-1">
                                                <div className="d-flex flex-column flex-grow-1 my-lg-0 my-2 pe-3">
                                                    <span className="fs-6 fw-bolder">{participant.name}</span>
                                                    <span className="text-gray-400 fw-bold fs-7">{participant.phone}</span>
                                                </div>
                                            </div>
                                        ))
                                    }
                                </div>
                                :
                                <h4 style={{ padding: "2rem", textAlign: "center" }}>
                                    {intl.formatMessage({ id: "FORM.LABEL.DATA_NOT_FOUND" })}
                                </h4>
                        }
                    </div>
                </div>
            }
        </div>
    );
};

export { DetailGroupContactChat };
